export const application_breakpoints = {
  mobile: 0, // optional
  tablet: 640,
  laptop: 1024,
  desktop: 1400
}
